import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { format } from "date-fns";
import { DebugFooterPanelComponent } from "../debug-footer-panel/debug-footer-panel.component";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DebugFooterPanelComponent],
})
export class FooterComponent implements OnInit {
  public year: string;

  constructor() {}

  ngOnInit() {
    this.year = format(new Date(), "yyyy");
  }
}
